import { Lob } from '@enums/Lob'
import { isVasWidget } from '@helpers/vasLandingPageHelper'
import { replaceDivWithHeadingTags, HEADING_TAGS, getpurpleRootContainerLayout } from '@configs/productWidget.config'

export const isSeoCar = (lob, isSem) => lob === Lob.CAR && !isSem
export const isSeoHealth = (lob, isSem) => lob === Lob.HEALTH && !isSem
export const isGradientBackground = (isSem, lob, isAutoWidget, widget) =>
  isVasWidget(widget)
    ? false
    : (!isSem && lob !== Lob.CAR && lob !== Lob.HEALTH) ||
      (isAutoWidget && lob !== Lob.HEALTH && (isSem || lob !== Lob.CAR))

export const isBackgroundImageGradient = (isSem, lob, isAutoWidget, widget) => {
  if (isVasWidget(widget)) {
    return (
      (lob === null && (isSem || isAutoWidget)) || ((isSem || lob === Lob.CAR || lob === Lob.HEALTH) && isAutoWidget)
    )
  } else {
    return (isSem || lob === Lob.CAR || lob === Lob.HEALTH) && isAutoWidget
  }
}
export const getClassNames = (baseClasses: string[], conditionalClasses: Record<string, boolean>) => {
  const base = baseClasses.filter(Boolean).join(' ')

  const conditional = Object.entries(conditionalClasses)
    .filter(([_, condition]) => condition)
    .map(([className]) => className)
    .join(' ')

  return `${base} ${conditional}`.trim()
}

export const getUrlWithQueryParams = url => {
  const originalUrl = new URL(url, window.location.origin)
  const newQueryParams = window.location.search.slice(1)
  return newQueryParams ? originalUrl.href + (originalUrl.search ? '&' : '?') + newQueryParams : originalUrl.href
}

export const getWidgetLayoutConfig = (
  content,
  lob,
  isSemPage,
  getAutoWidgetLayout,
  getHealthWidgetLayout,
  getCtaWidgetPurpleLayout
) => {
  const isAutoWidgetLayout = getAutoWidgetLayout[content?.widget] || false
  const isHealthWidgetPurpleLayout = getHealthWidgetLayout[content?.widget] || false
  const isSeoCarWidget = isAutoWidgetLayout && (isSeoCar(lob, isSemPage) || isVasWidget(content?.widget))
  const isCtaPurpleLayout = getCtaWidgetPurpleLayout[content?.widget]
  const isPurpleWidgetLayout = isVasWidget(content?.widget) && getpurpleRootContainerLayout[content?.widget]

  const isOldLayout =
    (isAutoWidgetLayout && (isSemPage || isSeoCarWidget)) ||
    isHealthWidgetPurpleLayout ||
    isCtaPurpleLayout ||
    isPurpleWidgetLayout

  return { isAutoWidgetLayout, isSeoCarWidget, isOldLayout, isHealthWidgetPurpleLayout, isCtaPurpleLayout }
}

export const getHeroImageSize = (isSeoCarWidget: boolean, isCtaPurpleLayout: boolean) =>
  isSeoCarWidget || isCtaPurpleLayout ? 360 : 450

export const getDynamicHeadingTag = (
  widget: string,
  isSeoCarWidget: boolean,
  isHealthWidgetPurpleLayout: boolean | undefined
) => {
  if (!replaceDivWithHeadingTags[widget]) return 'div'

  if (isSeoCarWidget) return HEADING_TAGS.SEO_CAR_WIDGET
  if (isHealthWidgetPurpleLayout) return HEADING_TAGS.HEALTH_WIDGET_PURPLE_LAYOUT

  return HEADING_TAGS.DEFAULT
}

export const getHideSectionState = (index: number, widget?: string, isMobileDevice?: boolean) => {
  const shouldSwap = isMobileDevice && isVasWidget(widget || '')
  return shouldSwap ? index === 0 : index !== 0
}
